import { jsx as _jsx } from "react/jsx-runtime";
import { transportIconMap } from "../constants";
export const TransportTypeIcon = ({ type, size = "20", }) => {
    const Icon = transportIconMap[type];
    return _jsx(Icon, { size: size });
};
